import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css';

const app = createApp(App);

app.use(store);
app.use(router);

store.dispatch('loadConfig').then(() => {
    app.mount('#app');
}).catch(err => {
    console.error('Erro ao carregar configurações do tenant:', err);
    app.mount('#app');
});